export enum ContactsDataEventObjectsEnum {
  ACCOUNT_DETAILS = 'account_details',
  COLUMN_SHOWN = 'column_shown',
  COLUMN_HIDDEN = 'column_hidden',
  PROPERTY_DRAGGED = 'property_dragged',
  COLUMN_CONFIG_SEARCHED = 'column_config_searched',
  COLUMN_CONFIG_OPENED = 'column_config_opened',
  ACCOUNT_NOTES_SECTION = 'account_notes_section',
  ACCOUNT_NOTES_EMPTY_STATE = 'account_notes_empty_state',
  ACCOUNT_NOTES_VIEW_MORE = 'account_notes_view_more',
  ACCOUNT_NOTES_LIST = 'account_notes_list',
  ACCOUNT_NOTE = 'account_note',
  ACCOUNT_NOTE_EDIT = 'account_note_edit',
  ACCOUNT_NOTE_DELETE = 'account_note_delete',
  ACCOUNT_NOTE_UNDELETE = 'account_note_undelete',
  ACCOUNT_OVERVIEW_TAB = 'account_overview_tab',
  ACCOUNT_PLANS_TAB = 'account_plans_tab',
  ACCOUNT_PLANS_PAGE = 'account_plans_page',
  ACCOUNT_PLANS_EMPTY_STATE = 'account_plans_empty_state',
  ACCOUNT_PLANS_ERROR = 'account_plans_error',
  ACCOUNT_PLANS_SEARCH = 'account_plans_search',
  ACCOUNT_PLAN_TEMPLATE_PICKER = 'account_plan_template_picker',
  ACCOUNT_PLAN_FROM_SCRATCH = 'account_plan_from_scratch',
  ACCOUNT_PLAN_TEMPLATE_SEARCH = 'account_plan_template_search',
  ACCOUNT_PLAN_TEMPLATE_ERROR = 'account_plan_template_error',
  ACCOUNTS_SEARCHED = 'accounts_searched',
  MORE_FILTERS_OPENED = 'more_filters_opened',
  FILTERS_CLEARED = 'filters_cleared',
  ACCOUNT_DETAILS_BREADCRUMB = 'account_details_breadcrumb',
  ACCOUNT_DETAILS_VIEW_MORE = 'account_details_view_more',
  ACCOUNT_HEALTH_METRICS_DATE_RANGE = 'account_health_metrics_date_range',
  ACCOUNT_SUMMARY = 'account_summary',
  ACCOUNT_PLAN_CREATE = 'account_plan_create',
  ACCOUNT_PLAN = 'account_plan',
  ACCOUNT_PLAN_CREATE_ERROR = 'account_plan_create_error',
  ACCOUNT_PLAN_CREATE_TASK = 'account_plan_create_task',
  ACCOUNT_PLAN_CREATE_TASK_DELETE = 'account_plan_create_task_delete',
  ACCOUNT_PLAN_CREATE_TASK_REORDERED = 'account_plan_create_task_reordered',
}
